import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector, ChangeDetectionStrategy} from '@angular/core';
import {QueryValue} from "../../../../../services/model/queryValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";
import {FilterValue} from "../../../../../services/model/filterValue";

@Component({
    selector: 'efast-filter-other-pension',
    templateUrl: 'efast-filter-other-pension.component.html',
    styleUrls: ['efast-filter-other-pension.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class EfastFilterOtherPensionComponent extends EfastFilterBaseComponent implements OnInit {

    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.title = this.cacheService.getLabelFromResource('FILTER:FILTEROtherPensionTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().PENSION;

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEROtherPensionLbl1'),
            this.staticsService.getPlanCodeFilter().CODE_TYPE_PENSION, false))
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEROtherPensionLbl2'),
            this.staticsService.getPlanCodeFilter().CODE_3B));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEROtherPensionLbl3'),
            this.staticsService.getPlanCodeFilter().CODE_3C));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEROtherPensionLbl4'),
            this.staticsService.getPlanCodeFilter().CODE_3D));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEROtherPensionLbl5'),
            this.staticsService.getPlanCodeFilter().CODE_3F));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEROtherPensionLbl6'),
            this.staticsService.getPlanCodeFilter().CODE_3H));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEROtherPensionLbl7'),
            this.staticsService.getPlanCodeFilter().CODE_3I));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTEROtherPensionLbl8'),
            this.staticsService.getPlanCodeFilter().CODE_3J));

        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    protected expandClick() {
        super.expandClick();
    }

    //extended
    protected searchChangeEvent() {
        this.setBucket(this.applicationService.getAfsForm().facets.plancode.buckets);
        super.searchChangeEvent();
    }

    //extended
    protected rowClick(filterValue: FilterValue) {

        super.rowClick(filterValue);

        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().PLAN_CODE, this.queryValue, true)
    }

}